import {
    imageClassName,
    pxArrayToRem,
    pxToRem,
    type StyleRule,
} from '@archipro-design/aria';

import {
    MOBILE_IMAGE_DIMENSIONS,
    DESKTOP_IMAGE_DIMENSIONS,
} from './TeamMemberModalContent';

export const TeamMemberDialogContentBase: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.screen.tablet]: {
        flexDirection: 'row',
    },
});

export const ProfileOverview: StyleRule = ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',

    [`& .${imageClassName}`]: {
        position: 'relative',
        width: pxToRem(MOBILE_IMAGE_DIMENSIONS.width),
        height: pxToRem(MOBILE_IMAGE_DIMENSIONS.height),
        background: 'transparent',
    },
    color: theme.siteVariables.colors.charcoal['000'],
    ...theme.siteVariables.textStyles.GTAmericaTrialFont.Medium65,
    [theme.screen.tablet]: {
        background: '#f6f6f6',
        padding: pxArrayToRem([68, 144]),
        [`& .${imageClassName}`]: {
            width: pxToRem(DESKTOP_IMAGE_DIMENSIONS.width),
            height: pxToRem(DESKTOP_IMAGE_DIMENSIONS.height),
        },
    },
});

export const TeamMemberName: StyleRule = ({ theme }) => ({
    fontSize: pxToRem(16),
    marginTop: pxToRem(47),
    marginBottom: pxToRem(8),
    textTransform: 'uppercase',
    lineHeight: '100%',
    textAlign: 'center',
    [theme.screen.tablet]: {
        fontSize: pxToRem(24),
        marginTop: pxToRem(37),
        marginBottom: pxToRem(12),
    },
});

export const TeamMemberRole: StyleRule = ({ theme }) => ({
    fontWeight: theme.siteVariables.fontWeightLight,
    fontSize: pxToRem(16),
    marginTop: pxToRem(12),
    textAlign: 'center',
    textTransform: 'uppercase',
    [theme.screen.tablet]: {
        fontSize: pxToRem(16),
    },
});

export const TeamMemberContactLinksContainer: StyleRule = ({ theme }) => ({
    display: 'flex',
    marginTop: pxToRem(26),
    [theme.screen.tablet]: {
        marginTop: pxToRem(39),
    },
});

export const TeamMemberContactIconButton: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['000'],
    borderRadius: '50%',
    height: pxToRem(32),
    width: pxToRem(32),
    aspectRatio: '1/1',
    border: `${pxToRem(1)} solid ${theme.siteVariables.colors.charcoal['000']}`,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',

    '& > *': {
        width: pxToRem(17),
        height: pxToRem(17),
        '& svg': {
            overflow: 'visible',
        },
    },
});

export const TeamMemberDescriptionBlock: StyleRule = ({ theme }) => ({
    height: 'auto',
    [theme.screen.tablet]: {
        flexGrow: 1,
        height: '100%',
        alignSelf: 'flex-start',
    },
});

export const CloseModalIconWrapper: StyleRule = ({ noSummary = false }) => ({
    display: 'flex',
    justifyContent: 'flex-end',
    margin: pxToRem(23),
    marginLeft: noSummary ? pxToRem(-68) : pxToRem(23),
    cursor: 'pointer',
});

export const DescriptionText: StyleRule = ({ theme }) => ({
    ...theme.siteVariables.textStyles.Text.Roman55,
    lineHeight: '130%',
    fontSize: pxToRem(16),
    padding: pxArrayToRem([46, 25]),
    [theme.screen.tablet]: {
        padding: pxArrayToRem([0, 64, 47, 64]),
        height: `calc(${pxToRem(735)} - ${pxToRem(75)})`,
        overflowY: 'auto',
        '& > p:first-child': {
            marginTop: pxToRem(-3),
            paddingTop: 0,
        },
    },
});

export const PhoneTooltip: StyleRule = ({ theme }) => ({
    zIndex: `${theme.siteVariables.zIndexes.overlayPriority} !important`,
    '& *': {
        fontSize: pxToRem(16),
        cursor: 'pointer !important',
    },
    '& a': {
        color: 'white',
        whiteSpace: 'nowrap',
        fontSize: pxToRem(16),
        textDecoration: 'underline',
    },
});
